import {getLastDateRange, getNullTextOfFilter, getStaticDateText} from "@/pages/datalab/utils/utils";
import {intersection, isEmpty, union} from 'lodash-es';
import moment from "moment";
import { FilterStringOptions, NUMBER_OPERATION_OPTIONS } from '@dbl/core/filter';
import type { IOptionType } from '@dbl/core/dataSource';
import { Operation } from '@dbl/core/filter';
import {storage} from "@/utils/utils";
import {CHART_EXPLORE_FILTERS} from '@dbl/core/global';

// };

export const renderDateInfos = (dateInfos: any[] = [], filterValue: any, isEn: boolean) => {
  try {
    if (!filterValue) return '';
    const dashboardFilters = Object.values(filterValue);
    const hasCompare = dateInfos[1].length > 0; // 过滤条件2中有日期类型
    const texts = dateInfos.map((infos, index) => {
      if (infos.length === 0) return '';
      const dateText = infos.map(({
				                            name,
				                            nameEn,
				                            value,
				                            column,
				                            tableId
			                            }: { name: string; nameEn: string; value: string; column: string; tableId: string; }) => {
        const dashboardDate = dashboardFilters.find((filter) => filter.table_id === tableId && filter.column === column);
        if (dashboardDate) {
          value = dashboardDate.value?.join(' ~ ');
          if (dashboardDate.operation === 'recent') {
            const [lastCount, dateType] = dashboardDate.value[0].split('-');
            const dateRange = getLastDateRange(lastCount, dateType);
            value = dateRange.join(' ~ ');
          }
					
        }
				
        return `${isEn ? nameEn : name}: ${value}`;
      }).join(' ');
      return `${hasCompare ? `${isEn ? 'Compare' : '对比项'}${index + 1}: ` : ''}${dateText}`;
    }).filter(text => !!text);
		
    return texts.length > 1 ? texts.join('<br/>') : texts[0];
		
  } catch (e) {
    console.error('报表页面图表内日期文本解析错误', e);
    return '';
  }
	
};

export const getScopeFilters = (filters: any[] = []) => {
  // 相同的table_id和column:
  // Date 类型, 查找报表筛选器中是否有相同的筛选器, 如果有, 取报表的显示名称, 没有使用后端返回的显示名称 (字段名称不区分中英文)
  // String 类型, 在都是include, 值取交集; 都是exclude, 值取并集;  如果一个是include, 一个是exclude, 则相当于两个筛选器都显示.
  //  同样也需要和报表筛选器对比, 获得显示名称
  //  一个是include, 一个是exclude的情况下, 需要注意区分哪个是报表的筛选器, 哪个是图表的筛选器
	
  try {
    // 由于关联字段显示问题, 后端增加了 报表名称数据的返回, 不需要前端自己遍历对比使用报表筛选器名称还是图表的筛选器名称, 所以删除之前的逻辑
    // const dashboardFiltersMap = new Map();
    // dashboardFilters?.forEach(filter => {
    //   // 如果报表筛选器中出现相同的字段, 则以最后一个字段为准
    //   const {table_id, column} = filter || {};
    //   dashboardFiltersMap.set(`${table_id}:${column}`, filter);
    // });
    const getStringScopeText = ({filter_name, display_name, column, value, operation, is_full}: any) => {
      const {
        text = '',
        text_en = ''
      } = FilterStringOptions.concat(NUMBER_OPERATION_OPTIONS).find(opt => opt.value === operation) || {};
      const prefix = `${filter_name || display_name || column}`;
      let scopeTextCn = `${prefix}（${text}）: `;
      let scopeTextEn = `${prefix}（${text_en}）: `;
      if (is_full) { // 新数据全选
        scopeTextCn += '全部';
        scopeTextEn += 'All';
        
      } else if (value === undefined) {
        scopeTextCn += '无';
        scopeTextEn += 'No Data';
				
      } else if (value?.length === 0) { // 说明用户没有勾选
  
        scopeTextEn += 'Please Select';
        scopeTextCn += '请选择';
        
        // if (is_full === false) {
        //   scopeTextEn += 'Please Select';
        //   scopeTextCn += '请选择';
        // } else { // 新数据is_full = true; 或者旧数据 (is_full = undefined && value?.length === 0) 代表全选
        //   scopeTextCn += '全部';
        //   scopeTextEn += 'All';
        // }
        
      } else if (value?.length <= 2) {
        const valueText = value.map(item => getNullTextOfFilter(item))?.join(',');
        scopeTextCn += valueText;
        scopeTextEn += valueText;
      } else {
  
        const count = value?.length || 0;
        
        // // is_full === undefined 说明是 旧数据
        // if ((is_full === undefined) && (selected_count !== undefined && selected_count > value?.length)) {
        //   count = selected_count;
        // }
        scopeTextCn += count;
        scopeTextEn += count;
      }
      return {scopeTextCn, scopeTextEn};
    };
    const getScopeText = ({operation, display_name, column, value, filter_name, selected_count, is_full, dateType, last_day}: any) => {
      // const mapKey = `${table_id}:${column}`;
      // const dashboardFilter = dashboardFiltersMap.get(mapKey);
      // let filter_name = ''; // filter_name是报表中给筛选器设置的名称, 不区分中英文
      //
      // if (dashboardFilter && (dashboardFilter.operation === operation || dashboardFilter.column_type === 'date')) {
      //   // dashboardFilter.operation === operation 判断是为了 String类型筛选器在图表和报表中operation不同时, 需要展示图表的名称, 而不是报表
      //   // dashboardFilter.operation === 'date' 是因为, 无论运算符是否相同, 只要是相同字段的日期类型, 都显示报表筛选器名称
      //   filter_name = dashboardFilter.filter_name;
      // }
			
      // 设置展示的筛选器名称和值
      // Date类型 展示 value[0] ~ value[1]
      // String类型 [] 是 ALL(中英文); value.length 超过两个展示数量;
      let scopeText = {
        scopeTextCn: '',
        scopeTextEn: ''
      };
      if ((operation === 'between') && /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(value?.[0])) { // 日期类型筛选器, 但字段不一定是date
        // /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(value?.[0]) 是为了验证value里返回的是日期字符串, 区分between是日期的区间 还是 数值筛选器的区间
        // && /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(value?.[0])
        // 因为后端返回的value格式不是常规的 [start, end], 而是 [date1, date2, date3, date4, .....]
        const start = dateType === 'month' ? moment(value[0]).format('YYYY-MM') : value[0];
        const end = value[1] && (dateType === 'month' ? moment(value[1]).format('YYYY-MM') : value[1]);
        scopeText.scopeTextCn = `${filter_name || display_name || column}: ${start}${value.length > 1 ? `~${end}` : ''}`;
        scopeText.scopeTextEn = scopeText.scopeTextCn;
      } else if (operation === 'recent') { // 动态日期类型
        const lastCount = value[0]?.startsWith('-1') ? -1 : (value[0]?.split('-')?.[0] || 7);
        
        const text = getStaticDateText(getLastDateRange(lastCount, dateType, last_day), dateType);
    
        scopeText.scopeTextCn = `${filter_name || display_name || column}: ${text}`;
        scopeText.scopeTextEn = scopeText.scopeTextCn;
    
      }  else if (['include', 'exclude'].includes(operation)) { // 字符串类型筛选器, 但字段不一定是string
        scopeText = getStringScopeText({filter_name, display_name, column, value, operation, selected_count, is_full});
      } else {
        // 数值类型筛选器的 文本显示
        const name = `${filter_name || display_name || column}:`;
        const afterText = column.column_type === 'percent' ? '%' : '';
        const option = NUMBER_OPERATION_OPTIONS.find((item: IOptionType) => item.value === operation);
        
        if (operation === Operation.Between) {
          const text = `${name} ${value?.[0] ?? ''}${afterText} ~ ${value?.[1] ?? ''}${afterText}`;
          scopeText.scopeTextCn = text;
          scopeText.scopeTextEn = text;
          
        } else if (operation !== Operation.NotNul) {
          const valueText = value?.[0] ? value?.[0] + afterText : '';
          scopeText.scopeTextCn = `${name} ${option?.text ?? ''} ${valueText}`;
          scopeText.scopeTextEn = `${name} ${option?.text_en ?? ''} ${valueText}`;
        } else {
          scopeText.scopeTextCn = `${name} ${option?.text ?? ''}`;
          scopeText.scopeTextEn = `${name} ${option?.text_en ?? ''}`;
        }
        
      }
			
      return {...scopeText};
			
    };
    
    const filtersMap = new Map();
    filters?.forEach((filter, index) => {

      const {table_id, column, operation, value, display_name, filter_name} = filter || {};
      
      // 针对字符串筛选器结构变化的转换
      if (['include', 'exclude'].includes(operation)) {
        filter.value = filter.is_full ? [] : filter.value;
        if (filter.filter_flag !== 1) { // 说明filter 是旧数据结构
          if (filter.value?.length === 0) {
            filter.value = [];
            filter.is_full = true;
            // if (filter?.selected_count === 0) {
            //   // 说明filter是 全不选
            //   filter.is_full = false;
            //   filter.value = [];
            // } else { // 说明是filter是全选
            //   filter.is_full = true;
            // }
          } else {
            filter.is_full = false;
          }
        }
      }
      
      const mapKey = `${table_id}:${column}`;
      if (filtersMap.has(mapKey)) { // 说明遇到了相同字段,当图表和报表有相同的Date类型字段时, 后端只会返回一个Date字段; 所以前端接收到的的字段只有String类型会出现相同的字段
        const oldFilter = filtersMap.get(mapKey);
        
        // 需求上
        // 只有当运算符相同的时候
        // 并且
        //   (下面的条件为了 两个报表筛选器互相关联的场景 )
        //   两个 filter_name(报表设置的筛选器名称) 都有值且相同
        //      或者 两个filter_name 有一个为空或者都为空的情况
        //
        // 才进行筛选器合并
        
        if (oldFilter?.operation === operation && (oldFilter.filter_name ? (filter_name ? oldFilter.filter_name === filter_name : true) : true)) {
          
          switch (oldFilter.column_type) {
            case 'string': {
              if (operation === 'include') {
                // 取交集 []空数组代表全部值, 而不是没有值
                // oldFilter.value 为[], value 有值[A], 交集结果为 [A];
                // oldFilter.value 有值[1, 2, 3], value 有值[2, 4, 5], 交集结果为[2];
                // oldFilter.value 有值[B], value 为[], 交集结果为[B];
                // oldFilter.value 为 undefined 说明没有交集结果为无, 再和任何value进行交集结果都应该是无
                if (oldFilter.is_full && filter.is_full) {
                  oldFilter.is_full = true;
                  oldFilter.value = [];
                } else {
                  let newValue = [];
                  if (oldFilter.is_full) {
                    if (isEmpty(oldFilter.scope_value)) {
                      oldFilter.value = value;
                      oldFilter.is_full = filter.is_full;
                    } else {
                      oldFilter.value = intersection(oldFilter.scope_value, value);
                      oldFilter.is_full = (oldFilter.value?.length === filter?.scope_value?.length);
                    }
                  } else if (filter.is_full) {
                    newValue = isEmpty(filter.scope_value) ? oldFilter.value : intersection(filter.scope_value, oldFilter.value);
                    oldFilter.value = newValue;
                    oldFilter.is_full = isEmpty(filter.scope_value) ? false : (newValue?.length === filter?.scope_value?.length);
                  } else {
                    
                    const inter1 = isEmpty(oldFilter?.scope_value) ? oldFilter?.value : intersection(oldFilter?.scope_value, value);
                    const inter2 = isEmpty(filter?.scope_value) ? filter?.value : intersection(filter?.scope_value, value);
                    newValue = intersection(inter1, inter2);
  
                    oldFilter.value = newValue?.length === 0 ? undefined : newValue; // oldFilter.value 有值[1, 2], value 有值[4, 5], 交集结果为应该是空数组[], 但空数组代表了全部值, 所以这里 交集为空的时候 value赋值为undefined
                    oldFilter.is_full = false;
                  }
                }
                
    
              } else {
                // 取并集 (与凡平沟通 都是exclude的时候取并集), []空数组代表全部值, 而不是没有值
                // oldFilter.value 为[], value 有值; 结果为 []
                // oldFilter.value 有值, value 有值; 结果 并集
                // oldFilter.value 有值, value 为[]; 结果 []
                if (oldFilter.is_full || filter.is_full) { // 说明两个筛选器有一个全选, 取并集结果是全选
                  oldFilter.value = [];
                  oldFilter.is_full = true;
                } else {
                  
                  const inter1 = isEmpty(oldFilter?.scope_value) ? oldFilter?.value : intersection(oldFilter?.scope_value, value);
                  const inter2 = isEmpty(filter?.scope_value) ? filter?.value : intersection(filter?.scope_value, value);
                  oldFilter.value = union(inter1, inter2);
                  // oldFilter.selected_count = (oldFilter.selected_count || 0) + (filter.selected_count || 0);
                  oldFilter.is_full = false;
                }
              }
              break;
            }
            case 'number':
            case 'float':
            case 'percent': {
              // 如果新的Filter是报表筛选器 (filter_name有值代表是报表筛选器), 那么返回新的值
              oldFilter.value = filter_name ?  value : oldFilter.value;
              break;
            }
          }
          
          // 重新计算 展示的文本
          const scopeText = getStringScopeText({
            filter_name: oldFilter.filter_name || filter.filter_name, // oldFilter.filter_name 和 filter.filter_name, 都有值且不相同时, 罗列展示, 不会执行到这一步.
            display_name,
            column,
            value: oldFilter.value,
            operation: oldFilter.operation,
            is_full: oldFilter.is_full,
            // selected_count: oldFilter.selected_count
          });
					
          oldFilter.scopeTextCn = scopeText.scopeTextCn;
          oldFilter.scopeTextEn = scopeText.scopeTextEn;
					
        } else {
          // 新增筛选器
          const scopeText = getScopeText(filter); //
					
          filtersMap.set(mapKey + index, {...filter, ...scopeText});
        }
				
      } else { // 说明是一个新字段
        const scopeText = getScopeText(filter); //
        filtersMap.set(mapKey, {...filter, ...scopeText});
      }
			
			
    });
		
    return Array.from(filtersMap.values());
		
  } catch (e) {
    console.error('getScopeFilters error: ', e);
    return [];
  }
	
};



// 计算图表探索的筛选器, 并保存在sessionStore中
export const saveChartExploreFilters = (filters: any[] = []) => {
  const exploreFilters: any[] = [];
  const chartFilters: any = {};
  const dashboardFilters: any = {};
  filters?.forEach((item) => {
    const key = `${item.table_id}:${item.column}`;
    if (item.filter_name) {
      dashboardFilters[key] = item;
    } else {
      chartFilters[key] = item;
      if (item.is_vs_compare_time) {
        // 和后端确认, 在多个有对比日期的日期字段中, 日期字段都会返回, 通过is_vs_compare_time判断使用哪个日期的 对比日期
        // 进入当前if判断, 说明item 不是报表筛选器, 且有对比日期的图表筛选器
        // 这个item不会进入 Object.keys(dashboardFilters) 循环判断中, 也不会加入到exploreFilters中, 用于继承
        // 但需要 这个item用于 探索图表时的继承 对比日期
        // 场景: 当报表和图表用于 筛选的日期字段不同时, 且同时都有对比日期设置, 和产品确认此时使用图表的日期字段和对比日期用于计算. 此时, 报表的图表卡片右上角的vs图标中显示的是图表日期字段基准日期和对比日期. 当用户更改了vs图标内部的对比日期设置后, 再进行探索时, 图表需要继承vs图标中设置的对比日期
        
        let lastCount = 7;
        let from = '1';
        if (item.operation === 'recent') {
          lastCount = item.value[0]?.startsWith('-1') ? -1 : (Number(item.value[0]?.split('-')?.[0] || 7));
          from = item.last_day;
        }
        
        exploreFilters.push({
          filterKey: item.filterKey,
          isAll: true,
          column_type: 'date',
          column_value: item.value,
          operation: item.operation,
          column: item.column,
          table_code: item.table_code,
          table_id: item.table_id,
          dateType: item.dateType,
          lastCount,
          from,
          compareTimes: item.compare_time,
        });
      }
    }
  });
  Object.keys(dashboardFilters).forEach((key) => {
    try {
      const item = dashboardFilters[key];
      const chartFilter = chartFilters[key];
      if (chartFilter) {
        
        // 报表和图表筛选器都存在的情况下
        
        if (['between', 'recent'].includes(item.operation)) {
          // ['between', 'recent'].includes(item.operation) 代表 报表筛选器是 日期筛选器, 但字段类型不一定是date
          if (chartFilter.column_type === 'date' && chartFilter.column_type === item.column_type) {
            // chartFilter.column_type === 'date' 代表 图表筛选器 是 日期筛选器, 且字段类型一定是date
            let lastCount = 7;
            let from = '1';
            if (item.operation === 'recent') {
              lastCount = item.value[0]?.startsWith('-1') ? -1 : (Number(item.value[0]?.split('-')?.[0] || 7));
              from = item.last_day;
            }
            exploreFilters.push({
              filterKey: item.filterKey,
              isAll: true,
              column_type: 'date',
              column_value: item.value,
              operation: item.operation,
              column: item.column,
              table_code: item.table_code,
              table_id: item.table_id,
              dateType: item.dateType,
              lastCount,
              from,
              compareTimes: item.compare_time,
            });
          }
          
        } else if (['include', 'exclude'].includes(item.operation)) {
          // ['include', 'exclude'].includes(item.operation) 代表 报表筛选器是 字符串下拉筛选器, 但字段类型不一定是String
          if (chartFilter.column_type === 'string' && chartFilter.column_type === item.column_type ) {
            // chartFilter.column_type === 'string' 代表 图表筛选器是 字符串下拉筛选器, 且字段类型一定是string
            exploreFilters.push({
              filterKey: item.filterKey,
              isAll: item.is_full ?? (item.value.length === 0),
              // item.is_full 说明是全选, 后端返回的value是空数组, 但如果全选状态下报表筛选器有自定义选项, 那么无法在图表继承时展示
              // customValues 是记录的用户自定义的选项, 所以在全选状态下赋值给 column_value, 在图表继承时可以展示自定义选项
              column_value: (item.is_full && (!isEmpty(item.customValues))) ? item.customValues : item.value,
              customValues: item.customValues,
              column_type: 'string',
              operation: item.operation,
              column: item.column,
              table_code: item.table_code,
              table_id: item.table_id,
            });
            
          }
          
        } else { // 报表的数值类型筛选器的字段类型是 number, float, percent 类型字段
          if (['number', 'float', 'percent'].includes(chartFilter.column_type)) {
            // 图表筛选器的字段类型
            exploreFilters.push({
              filterKey: item.filterKey,
              isAll: true,
              column_value: item.value,
              operation: item.operation,
              column: item.column,
              table_code: item.table_code,
              table_id: item.table_id,
              column_type: item.column_type
            });
            
          }
        }
        
      } else {
        // 只有报表筛选器, 没有图表筛选器
        // 报表筛选器字段是 Date 或者 Number, 但运算符是include或者exclude; 说明报表这边是以下拉选项的筛选器, 无法继承到图表那边
        // eslint-disable-next-line array-callback-return
        if (item.column_type !== 'string' && FilterStringOptions.some(({value}) => value === item.operation)) return;
  
        // String或者Number类型的字段作为了 报表的日期筛选器,
        if (item.column_type !== 'date' && ['between', 'recent'].includes(item.operation)) return;
  
        let lastCount = 7;
        let from = '1';
        if (item.operation === 'recent') {
          lastCount = item.value[0]?.startsWith('-1') ? -1 : (Number(item.value[0]?.split('-')?.[0] || 7));
          from = item.last_day;
        }


        exploreFilters.push({
          filterKey: item.filterKey,
          isAll: item.is_full ?? (item.value.length === 0),
          column_value: (item.column_type !== 'date') ? union((item.value ?? []), (item.customValues ?? [])) : item.value, // 当is_full是true的时候, 后端返回的value是空数组, 在有自定义选项的情况下, 前端无法展示自定义选项
          // customValues是前端上传给后端的已被勾选的自定义选项值, 后端再原封返回, 用于前端展示自定义选项
          operation: item.operation,
          column: item.column,
          table_code: item.table_code,
          table_id: item.table_id,
          dateType: item.dateType,
          scope_value: item.scope_value,
          column_type: item.column_type,
          lastCount,
          from,
          compareTimes: item.compare_time,
        });
      }
    } catch (e) {
      console.log('探索继承筛选器错误: ', e);
    }
  });
  
  storage.setSessionStorageItem(CHART_EXPLORE_FILTERS, exploreFilters);
};

export interface ICompareTimeDataLike {
  filterId?: string;
  defaultCompareTimes?: unknown[];
}

/** 图表/表格卡片「更多」菜单：是否已启用时间对比（有对比时间段） */
export const hasActiveCompareTime = (
  compareTimeData: ICompareTimeDataLike | null | undefined,
  filterValues?: Array<{
    filterKey?: string;
    table_id?: string;
    compare_time?: unknown;
  }> | null,
): boolean => {
  if (!compareTimeData?.filterId) {
    return false;
  }
  const hasTimes = (times: unknown): boolean =>
    Array.isArray(times) && times.length > 0;

  const hasActiveInFilters = filterValues?.some(
    (item) =>
      (item?.filterKey === compareTimeData.filterId ||
        item?.table_id === compareTimeData.filterId) &&
      hasTimes(item?.compare_time),
  );
  if (hasActiveInFilters) {
    return true;
  }
  return hasTimes(compareTimeData.defaultCompareTimes);
};
